import axios from 'axios'
import { RootStore } from '../data/store'
import { APIEndPoints } from './APIEndpoints'
import { BASE_URL, sitConfig } from './config'

const responseParser = (response: any) => {
  return response
}

const bulkOnboardingFileUpload: any = (file: File, mid: string, tokens: any) => {
  const reqBody = new FormData()
  reqBody.append('file', file)
  reqBody.append('type', 'BULK_BENEFICIARY')
  reqBody.append('parentIdentificationNumber', mid)
  const config = {
    onUploadProgress: (progressEvent: any) => {
      const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
      if (!isNaN(percentCompleted)) {
        RootStore.settings.metaData.setFileUploadProgress(percentCompleted)
      }
    },
    headers: {
      ...sitConfig(tokens).headers,
      'Content-Type': 'multipart/form-data',
      formData: true,
      parseReqBody: true,
    },
  }
  return axios.post(`${BASE_URL}${APIEndPoints.uploadBulkBeneficiaryFile}`, reqBody, config).then((response) => {
    return responseParser(response)
  })
}

export { bulkOnboardingFileUpload }
